import { useEffect, useState } from 'react';
import type { Lot } from '../data/mockLots';
import { useCountdown } from '../hooks/useCountdown';
import { RingTimer } from './RingTimer';
import { SkinFrame } from './SkinFrame';
import { BidderPill } from './BidderPill';

export function LiveLotCard({ lot, index, onSelect }: { lot: Lot; index: number; onSelect?: () => void }) {
  const secondsLeft = useCountdown(lot.timerEndsAt);
  const [flash, setFlash] = useState(0);

  useEffect(() => {
    setFlash((f) => f + 1);
  }, [lot.bidsCount]);

  return (
    <article
      onClick={onSelect}
      className={`anim-rise relative grid grid-cols-[92px_1fr_auto] gap-3 p-3 border border-edge bg-bg-elev/60 hover:border-edge-bright transition-colors ${onSelect ? 'cursor-pointer active:bg-bg-elev/80' : ''}`}
      style={{ animationDelay: `${120 + index * 60}ms` }}
    >
      <div className="relative overflow-hidden" style={{ aspectRatio: '1 / 1' }}>
        <SkinFrame weapon={lot.weapon} palette={lot.palette} size="sm" />
      </div>

      <div className="flex flex-col justify-between min-w-0 py-0.5">
        <div className="min-w-0">
          <h3 className="font-display font-semibold text-[15px] leading-tight text-fg truncate">
            {lot.weaponLabel}{' '}
            <span style={{ color: lot.palette.accent ?? lot.palette.to }}>| {lot.skinName}</span>
          </h3>
          <p className="font-mono text-[10px] tracking-wider text-fg-muted mt-1">
            {lot.wear} · ${lot.marketPrice.toFixed(0)} market
          </p>
        </div>

        <div className="flex items-center gap-2 mt-1.5">
          <BidderPill bidder={lot.lastBidder} size="xs" showCount />
          <span className="font-mono text-[9px] tracking-wider text-fg-dim">
            {lot.bidsCount} bids
          </span>
        </div>
      </div>

      <div className="flex flex-col items-end justify-between gap-1.5">
        <RingTimer
          secondsLeft={secondsLeft}
          size={52}
          stroke={3.5}
          scaleSec={60}
          flashTrigger={flash}
          showLabel={false}
        />
        <div
          className="font-mono font-bold text-[16px] tabular-nums leading-none"
          style={{ color: '#00ff94' }}
        >
          ${lot.currentPrice.toFixed(2)}
        </div>
      </div>
    </article>
  );
}
